import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var _a, _b, _c, _d;

import { BORDER_RADIUS, COLORS, FONT } from '../../../constants';
import { breakpoints } from '../../shared';
import { ColorVariations } from '../../../internalConstants';
export var breadcrumb = (_a = {
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  maxWidth: 'auto',
  padding: '16px 10px'
}, _a[breakpoints.medium] = {
  maxWidth: 'calc(100% - 100px)',
  padding: '16px 24px 16px 18px'
}, _a[breakpoints.large] = {
  padding: '16px 32px 16px 26px'
}, _a);
export var desktopDivider = (_b = {
  width: 8,
  height: 10,
  margin: '0 2px',
  display: 'none'
}, _b[breakpoints.medium] = {
  display: 'inline-block'
}, _b);
export var mobileDivider = (_c = {
  transform: 'rotateY(180deg)',
  width: 8,
  height: 10,
  margin: '0 2px 0 6px'
}, _c[breakpoints.medium] = {
  display: 'none'
}, _c);
export var item = (_d = {
  display: 'none',
  lineHeight: '32px',
  padding: '0 6px',
  fontFamily: FONT.family,
  fontSize: FONT.sizes.h3.fontSize,
  textDecoration: 'none',
  ':nth-last-of-type(-n+2)': {
    display: 'block',
    fontSize: FONT.sizes.regular.fontSize
  },
  ':nth-last-of-type(1)': {
    fontSize: FONT.sizes.h3.fontSize,
    width: 'calc(100% - 16px)'
  }
}, _d[breakpoints.medium] = {
  ':nth-last-of-type(n-1)': {
    display: 'inline-block',
    fontSize: FONT.sizes.h3.fontSize,
    width: 'auto'
  }
}, _d);
export var linkItem = {
  borderRadius: BORDER_RADIUS.medium,
  '&:hover': {
    background: COLORS.grays.background
  },
  '&:focus': {
    color: 'currentColor'
  }
};
export var inactiveItem = {
  color: COLORS.grays.gray,
  '&:hover': {
    color: COLORS.grays.gray
  },
  fontWeight: 'normal'
};
export var activeItem = {
  color: COLORS.grays.darkest,
  '&:hover': {
    color: COLORS.grays.darkest
  },
  fontWeight: 'bold'
};
export var contextStyles = {
  color: COLORS.grays.gray,
  display: 'inline-flex',
  alignItems: 'center'
};
export var contextStylesItem = {
  marginRight: '4px'
};
export function navItemsStyles() {
  return {
    display: 'block',
    width: '100%',
    fontWeight: 'normal',
    color: COLORS.grays.darkest,
    '&:hover': {
      backgroundColor: ColorVariations.primaryBlueOpacity,
      cursor: 'pointer',
      color: COLORS.grays.darkest
    }
  };
}
export function navItemsPlaceholderStyles() {
  return Object.assign(navItemsStyles(), {
    color: COLORS.grays.gray,
    '&:hover': {
      backgroundColor: 'inherit',
      cursor: 'initial',
      color: COLORS.grays.gray
    }
  });
}
export var DropdownHandle = _styled("div", {
  target: "eretpf10",
  label: "DropdownHandle"
})(__assign(__assign({}, linkItem), {
  padding: '0 6px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  cursor: 'pointer',
  '.trustpilot-icon': {
    width: '8px',
    height: '8px',
    marginLeft: '6px',
    fill: COLORS.grays.light
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/breadcrumbs/styled.js
// module id = 204
// module chunks = 0